import { TopbarConfig } from '../models/topbar.model';

export const TOPBAR_CONFIG: TopbarConfig = {
  overlayCardStyles: {
    background: 'var(--surface-card)',
    backgroundType: 'color',
    textColor: 'var(--text-color)',
    styleClass: 'border-1 border-solid surface-border py-4 px-4',
  },
  activePlansTitle: 'Piani Attivi',
  noActivePlansText: 'Nessun piano attivo.',
  manageButtonLabel: 'Gestisci',
  logoutButtonLabel: 'Log out',
  loginButtonLabel: 'Accedi',
};
